import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import QRCode from 'react-qr-code';
import CtaButton from '../../ctaButton/ctaButton';
import useSetHeroImg from '../../../hooks/useSetHeroImg';
import styles from './heroHomeTemplate.module.scss';
import HeroHomePrequalCard from '../../heroHomePrequal/prequalCard/heroHomePrequalCard';
import HeroHomePrequal from '../../heroHomePrequal/prequaldefault/heroHomePrequal';
import useWindowDimensions from '../../../hooks/useWindowDimensions';
import SmartImage from '../../smartImage/smartImage';
import LoginWidget from '../../loginWidget/loginWidget';
import MobileAppCard from '../../mobileApp/mobileApp';
import handleCTAClick from '../../../services/helpers/handleCTAClick';

function HeroHomeTemplateFullBackground({
  title = '',
  titleBlue = '',
  heroDesc = '',
  image = null,
  mobImage,
  prequalItems = null,
  backgroundSize = 'cover',
  appUsage,
  mobileApp,
  scannerHeader = '',
  scannerNote = '',
  widgetLoggedinHeader = '',
  widgetLoggedoutHeader = '',
  widgetLoggedinButtontext = '',
  widgetLoggedoutButtontext = '',
  scannerURL = '',
  loggedinUrlRedirect = '',
  isExistingUser,
  isUserLoggedIn,
  isPersonalization,
}) {
  const [docked, setDocked] = useState(false);
  const { width } = useWindowDimensions();
  const [isMobile, setIsMobile] = useState(false);
  const [android, setAndroid] = useState(false);
  const [ios, setIos] = useState(false);

  const url = `/${loggedinUrlRedirect}`;

  const widgetProps = {
    options: {
      theme: 'lc-diamond',
      targetURL: url,
      loginButtonText: widgetLoggedoutButtontext,
      width: '100%',
      height: '265',
    },
    onLogin: (err) => {
      if (!err) window.location = url;
    },
  };

  useEffect(() => {
    if (width <= 1024) {
      const { userAgent } = navigator;
      if (/android/i.test(userAgent)) {
        setAndroid(true);
      }
      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        setIos(true);
      }
    }
    if (width < 768) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  }, [width]);
  useEffect(() => {
    const isDocked =
      window.document.documentElement.scrollTop >= 0 || window.scrollY >= 0;
    setDocked(isDocked);
  }, []);

  const heroImg = useSetHeroImg(image, mobImage, width);

  const displayPrequal = () => {
    if (prequalItems?.prequalType === 'Home Card') {
      return (
        <HeroHomePrequalCard
          {...prequalItems}
          isPersonalization={isExistingUser && isPersonalization}
        />
      );
    }
    return (
      <div className={styles.heroSingleImagePrequalDefault}>
        <HeroHomePrequal {...prequalItems} />
      </div>
    );
  };

  const displayLoginWidget = () => {
    return (
      <div className={styles.loginPersonalizationWrapper}>
        <div className={styles.heroHomeLoginWidgetHeader}>
          {isUserLoggedIn
            ? parse(widgetLoggedinHeader)
            : parse(widgetLoggedoutHeader)}
        </div>
        {isUserLoggedIn && (
          <CtaButton
            aria-label={widgetLoggedinButtontext}
            label={widgetLoggedinButtontext}
            variant="solid"
            data-testid={widgetLoggedinButtontext}
            href={loggedinUrlRedirect}
            className={styles.heroHomeLoggedInButton}
            fullWidth
            onClick={(e) => handleCTAClick(e, { link: loggedinUrlRedirect })}
          />
        )}
        <div className={styles.loginWidgetContainer}>
          {!isUserLoggedIn && <LoginWidget {...widgetProps} />}
        </div>
        <div className={styles.heroHomeLoginWidgetScannerWrapper}>
          {!android && !ios ? (
            <>
              <div className={styles.scannerContainer}>
                <QRCode size={85} value={scannerURL} />
              </div>
              <div>
                <div className={styles.loginWidgetScannerHeader}>
                  {parse(scannerHeader)}
                </div>
                <div className={styles.loginWidgetScannerNote}>
                  {parse(scannerNote)}
                </div>
              </div>
            </>
          ) : (
            (android || ios) && (
              <div className={styles.heroHomeAppWrapper}>
                <div className={styles.heroHomeAppUsage}>{parse(appUsage)}</div>
                <div className={styles.loginWidgetScannerNote}>
                  {parse(scannerNote)}
                </div>
                {ios ? (
                  <MobileAppCard appleAppIcon={mobileApp.appleAppIcon} />
                ) : (
                  <MobileAppCard googlePlayIcon={mobileApp.googlePlayIcon} />
                )}
              </div>
            )
          )}
        </div>
      </div>
    );
  };

  return (
    <>
      <section className={styles.heroPrequalWithSingleImage}>
        <div
          className={`${styles.sectionContainer} ${
            isExistingUser && isPersonalization && !isUserLoggedIn
              ? styles.verticalAlign
              : ''
          }`}
        >
          <div
            className={`${styles.contentContainer} ${
              isExistingUser && isPersonalization && isUserLoggedIn
                ? styles.marginTop
                : ''
            }`}
          >
            <div className={styles.content}>
              {(!isExistingUser || !isPersonalization) && (
                <>
                  <div className={styles.heroHeader}>
                    {title || titleBlue ? (
                      <h1
                        className={`${styles.headerTitleScroll} ${
                          docked && styles.headerTitleScrollDocked
                        }`}
                      >
                        {title && title}{' '}
                        {titleBlue && <strong>{titleBlue}</strong>}
                      </h1>
                    ) : null}
                    {heroDesc && (
                      <div
                        className={`${styles.headerDescScroll} ${
                          docked && styles.headerDescScrollDocked
                        }`}
                      >
                        {parse(heroDesc)}
                      </div>
                    )}
                  </div>
                  {!isMobile && prequalItems && displayPrequal()}
                </>
              )}
              {isExistingUser &&
                isPersonalization &&
                !isMobile &&
                displayLoginWidget()}
            </div>
          </div>
          {heroImg?.src ? (
            <div
              className={`${
                prequalItems?.prequalType === 'Home Card'
                  ? styles.heroClipImageCardHeight
                  : styles.heroClipImageHeight
              } ${styles.heroClipImage} ${
                backgroundSize === 'contain' && styles.bgContain
              }`}
            >
              <SmartImage
                src={heroImg}
                alt={heroImg?.alt}
                width={1728}
                height={700}
                priority
              />
            </div>
          ) : null}
        </div>
      </section>
      {isExistingUser && isPersonalization && (
        <div className={styles.prequalWrapper}>
          {isMobile && displayLoginWidget()}
          <div
            className={`${styles.content} ${
              isMobile ? styles.heroHomePrequalMobile : ''
            }`}
          >
            {prequalItems && displayPrequal()}
          </div>
        </div>
      )}
      {(!isExistingUser || !isPersonalization) &&
        isMobile &&
        prequalItems?.prequalType === 'Home Card' && (
          <div className={styles.heroHometemplatePrequalSectionForCardMobile}>
            <div className={styles.heroHomePrequalMobile}>
              <HeroHomePrequalCard {...prequalItems} />
            </div>
          </div>
        )}
    </>
  );
}

HeroHomeTemplateFullBackground.propTypes = {
  title: PropTypes.string,
  heroDesc: PropTypes.string,
  titleBlue: PropTypes.string,
  image: PropTypes.shape({
    src: PropTypes.string.isRequired,
    alt: PropTypes.string,
  }),
  mobImage: PropTypes.shape({
    src: PropTypes.string.isRequired,
    alt: PropTypes.string,
  }),
  prequalItems: PropTypes.object,
  backgroundSize: PropTypes.string,
};

export default HeroHomeTemplateFullBackground;
